var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.49 7.143a6.633 6.633 0 11-13.265 0 6.633 6.633 0 0113.265 0zm-.603 0a6.03 6.03 0 11-12.059 0 6.03 6.03 0 0112.06 0zM7.255 3.789a.264.264 0 01.527 0v3.655h3.392a.302.302 0 010 .603h-3.92V3.79z",
    fill: "url(#paint0_linear_761_540)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.715 7.143a7.143 7.143 0 1114.286 0 7.143 7.143 0 01-14.286 0zm7.143-5.52a5.52 5.52 0 100 11.04 5.52 5.52 0 000-11.04zM6.745 3.79a.774.774 0 111.548 0v3.145h2.881a.812.812 0 110 1.623h-4.43V3.79z",
    fill: "url(#paint1_linear_761_540)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_540",
    x1: 7.858,
    y1: 0,
    x2: 7.858,
    y2: 14.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_540",
    x1: 7.858,
    y1: 0,
    x2: 7.858,
    y2: 14.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99607"
  })))));
}
SvgClock.displayName = 'Clock';
export default SvgClock;